import PropTypes from 'prop-types';

// @mui material components
import Card from "@mui/material/Card";

// Data
import { useMatch } from 'react-router-dom';


import { useQuery, useMutation } from '@tanstack/react-query';

import clearwaysAPI from 'modules/clearways/api';
import groupsAPI from 'services/api/groups';
import bksAPI from 'services/api/bks';

import EventForm from "modules/clearways/components/EventForm";


import { useAuth0 } from "@auth0/auth0-react";
import { Box } from "@mui/material";
import { disableMap } from "utils/map";
import { useSoftUIController } from "hooks/context";
import { wrapper, loadingScreen } from "utils/wrapper";

function updateEvent(data) {
    // console.log(data);
    clearwaysAPI.saveClearwayEventWithID(data._id, data);
}

function ClearwaysEventEdit({ map, user }) {
    disableMap(map);

    bksAPI.loadToken(useAuth0());
    groupsAPI.loadToken(useAuth0());
    clearwaysAPI.loadToken(useAuth0());
    const [controller] = useSoftUIController();
    const { deviceLayout } = controller;

    const { event_id } = useMatch('clearways/events/:event_id/edit').params;

    const event = useQuery({
        queryKey: ['getClearwayEventWithID', event_id],
        queryFn: async () => {
            return await clearwaysAPI.getClearwayEventWithID(event_id);
        }
    });

    const groups = useQuery({
        queryKey: ['getGroups', event_id],
        queryFn: async () => {
            return await groupsAPI.getAllGroups();
        }
    });

    const devices = useQuery({
        queryKey: ['getAllClearwaysDevices'],
        queryFn: async () => {
            return await bksAPI.getAllClearwaysDevices();
        }
    })

    const { mutate } = useMutation({
        mutationFn: (values) => updateEvent(values),
    })

    if (event.isLoading || groups.isLoading || devices.isLoading) {
        return loadingScreen(deviceLayout, false);
    }

    if (event.error || groups.error || devices.error) {
        return "Error!";
    }

    if (!event.data || !groups.data || !devices.data) {
        return loadingScreen(deviceLayout, false);
    }

    return wrapper((
        <Box p={1}>
            <Card>
                <EventForm event={event.data} groups={groups.data} devices={devices.data} onSubmit={mutate} user_type={user.user.user_type} />
            </Card>
        </Box>
    ), deviceLayout, true
    );
}

ClearwaysEventEdit.propTypes = {
    map: PropTypes.object,
    user: PropTypes.object
}

export default ClearwaysEventEdit;